import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Icon from '../icon/Icon';
import { ProductImage } from '../../components/aurora';

class ImageSlider extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentIndex: 0
    };
  }

  goBack = e => {
    const { currentIndex } = this.state;
    e.stopPropagation();
    this.setState({
      currentIndex: currentIndex - 1
    });
  };

  goForward = e => {
    const { currentIndex } = this.state;
    e.stopPropagation();
    this.setState({
      currentIndex: currentIndex + 1
    });
  };

  render() {
    const { products, previewProduct, selectedProduct, handleMouseLeave } = this.props;
    const { currentIndex } = this.state;
    const hasOverflow = products.length > 3;

    return (
      <div className='imageSlider__outer mt4-md'>
        {hasOverflow && currentIndex > 0 && (
          <button
            className='imageSlider__arrow-left'
            data-desc='gridwall__productCard_imageSlider-right'
            onClick={this.goBack}
            type='button'
          >
            <Icon name='chevron-left' alt='left' onClick={this.goBack} />
          </button>
        )}
        <ul className='imageSlider__inner flex-container center row'>
          {products
            .slice(currentIndex, currentIndex + 3)
            .filter(item => item !== null)
            .map(product => (
              <li
                key={product.id + product.productCode}
                className={classnames('imageSlider__image_container flex-container center p2-sm ml1-sm mr1-sm', {
                  selected: product.productCode === selectedProduct.productCode,
                  isUnavailable:
                    product.availabilityStatus === 'Available Soon' || product.availabilityStatus === 'Out of Stock'
                })}
              >
                <span hidden data-desc='gridwall__productCard_productCode'>
                  {product.productCode}
                </span>
                <span hidden data-desc='gridwall__productCard_image_colorCode'>
                  {product.color}
                </span>
                <span hidden data-desc='gridwall__productCard_image_colorName'>
                  {product.colorName}
                </span>
                <div
                  onClick={e => previewProduct(product, e)}
                  onMouseEnter={() => previewProduct(product)}
                  onMouseLeave={handleMouseLeave}
                >
                  <ProductImage alt={product.productCode} productCode={product.productCode} />
                </div>
              </li>
            ))}
        </ul>
        {hasOverflow && !!products[currentIndex + 3] && (
          <button
            className='imageSlider__arrow-right'
            data-desc='gridwall__productCard_imageSlider-right'
            onClick={this.goForward}
            type='button'
          >
            <Icon name='chevron-right' alt='right' />
          </button>
        )}
      </div>
    );
  }
}

ImageSlider.propTypes = {
  products: PropTypes.array.isRequired,
  selectedProduct: PropTypes.object.isRequired,
  previewProduct: PropTypes.func.isRequired,
  handleMouseLeave: PropTypes.func.isRequired
};

export default ImageSlider;
